// @flow
import BaseCollection from "../base/BaseCollection";
import ActionCollection from "../actions/ActionCollection";
import ListItemModel from "../list/ListItemModel";

import ConfigurationException from "../../exceptions/ConfigurationException";

import type ListModel from "../list/ListModel";

/**
 * Collection of list items
 */
class ListItemCollection extends BaseCollection<ListItemModel> {
  /**
   * Create a list item collection from the given list
   */
  static createFromList(list: ListModel): ListItemCollection {
    const _embedded = list.getData("_embedded");
    if (_embedded != null) {
      if (Array.isArray(_embedded)) {
        throw new ConfigurationException(
          `One record panel with multiple tables is not supported, place all types in one panel for the panel with key ${list.key}`,
        );
      }

      const dynamicschema = list.getData("dynamicschema");

      const collection = _embedded.results.map((resultItem) => {
        const [key] = Object.keys(resultItem);
        const listitemData = resultItem[key];
        listitemData.dynamicschema = dynamicschema;

        const listitemContributions = list.contributions.results[key];

        return ListItemModel.createFromListResult(
          key,
          listitemData,
          listitemContributions,
          list.modelOptions,
        );
      });

      return new ListItemCollection(collection);
    }

    return new ListItemCollection();
  }

  /**
   */
  get additionalDetailRoutePath(): string {
    if (this.isEmpty) {
      return "__NON_EXISTING_ROUTE__";
    }

    const allRoutes = this.all
      .map((listItem) => listItem.additionalDetailRoutePath)
      .join("|");

    if (allRoutes.includes("|")) {
      return `(${allRoutes})`;
    }

    return allRoutes;
  }

  /**
   */
  get actionCollection(): ActionCollection {
    const actions = new ActionCollection();

    this.all.forEach((listItem) => {
      actions.collection.push(...listItem.actionCollection.all);
    });

    return actions;
  }
}

export default ListItemCollection;
